// Remove the following lines, if you do not need any of Bootstrap's JavaScript features
import Popper from "popper.js";
window.jQuery = $;
window.$ = $;

require("bootstrap");

import "./scripts/select2.min";

import "./scripts/jquery.countdown.min";
import "./scripts/slick.min";
import "./scripts/bootstrap-datepicker.min";
import "./scripts/chart.min";
import "./scripts/jquery.countdown.min";
import "./scripts/circle-progress.min";
import "./scripts/jquery.validate.min";

import "./scripts/chart.min";

import "./scripts/circle-progress.min";
import "./scripts/profile";

import "./scripts/registerSteps";

import "./scripts/custom";
import "./scripts/quiz";

import "./scripts/landing";
import "./scripts/zoomUS";

// import RabbitLyrics from 'rabbit-lyrics';

// import videojs from './scripts/videojs';
// import "./scripts/dash.all.debug";
// import dashjs from "./scripts/videojs-dash";

import videojs from "video.js";
import "videojs-contrib-dash";

import "./scripts/jquery-ui.min";
import "./scripts/jquery.ui.touch-punch.min";
import "./scripts/quizInit";
// import "./scripts/infinite-scroll.pkgd";

// import "./scripts/InfiniteScroll";

$(function () {
  $("[data-countdown]").each(function () {
    var $this = $(this),
      finalDate = $(this).data("countdown");
    $this.countdown(finalDate, function (event) {
      $this.html(
        event.strftime(
          '<span class="tim">%D</span> : <span class="tim">%H</span> : <span class="tim">%M</span> : <span class="tim">%S</span>'
        )
      );
    });
  });
});

//variable for  videojs to cam use outSide our bundleJs
window.ourPlayer = videojs;

window.lyrcInit = function (theplayer) {
  let lines = document.getElementsByClassName("line");
  for (var i = 0; i < lines.length; i++) {
    lines[i].addEventListener("click", function () {
      let timeupdated = this.getAttribute("startsAt");
      theplayer.currentTime(timeupdated);
      this.classList.add("active");
    });
  }

  theplayer.on("timeupdate", timeupdateHandler);
 
  
  function timeupdateHandler(evt) {
    var i = 1;                  //  set your counter to 1
    let time = theplayer.currentTime() / 1000;
 

    for (var i = 0; i < lines.length; i++) {
      if (time >= lines[i].getAttribute("startsAt") / 1000) {
        if (i > 0) {
          lines[i - 1].classList.remove("active");
        }
        lines[i].classList.add("active");


      


          
      
      } else {
        lines[i].classList.remove("active");
      }
    }
  }
};

// load more

$(".loadMore").click(function () {
  let data = $(this).attr("data-toload");
  var output = "";
  $(".data-to-load .loader-ellips").removeClass("d-none");
  $.getJSON(data, function (data) {
    $(".data-to-load").html(data);
    //gallery
    $(".loader-ellips").addClass("d-none");
  });
});
